<template>
    <div class="issue-badge-in-inspection-form">
        <div class="issue-badge-in-inspection-form-badge">
            <ReadinessBadge
            status="'Removed'"
            :dot="dot"
            :level="currentBadge"
            :view="'ReadOnly'"
            />
        </div>
        <div class="issue-badge-in-inspection-form-content">
            <ReadyForIndicator v-if="levelForDropdown" :level="levelForDropdown"/>
            <GrandBadgeDropdown
            :value="currentBadge"
            :level="levelForDropdown"
            @input="handleBadgeSelection"
            />
        </div>
    </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import GrandBadgeDropdown from "@components/EvaluationGrandBadge/GrandBadgeDropdown.vue";
import ReadyForIndicator from "@components/ReadyForIndicator/ReadyForIndicator.vue";
import ReadinessBadge from "@components/ReadinessBadge/ReadinessBadge.vue";

const props = defineProps({
    dot: {
        type: String,
        required: true,
        default: "Good Standing",
    },
    currentBadge: {
        type: String,
        required: true,
        default: "Apprentice",
    },
    readyForLevel: {
        type: String,
        default: null,
    },
});

const emit = defineEmits(['badge-selected']);

const selectedBadge = ref(null);

const levels = ['Apprentice', 'Professional', 'Coach', 'Master'];

const nextLevel = computed(() => {
    const currentIndex = levels.indexOf(props.currentBadge);
    
    if (currentIndex === -1 || currentIndex === levels.length - 1) {
        return null;
    }
    
    return levels[currentIndex + 1];
});

const levelForDropdown = computed(() => {
    if (props.readyForLevel && props.readyForLevel !== 'Novice') {
        const currentIndex = levels.indexOf(props.currentBadge);
        const readyForIndex = levels.indexOf(props.readyForLevel);
        
        if (readyForIndex > currentIndex) {
            return props.readyForLevel;
        }
    }
    
    return null;
});

const handleBadgeSelection = (badgeData) => {
    selectedBadge.value = badgeData?.value || null;
    emit('badge-selected', badgeData);
};
</script>

<style scoped>
.issue-badge-in-inspection-form {
    display: flex;
    flex-direction: column;
    align-items: end;
    gap: 20px;
    width: fit-content;
}

.issue-badge-in-inspection-form-content {
    display: flex;
    align-items: center;
    gap: 7px;
}
</style>